import PropTypes from "prop-types";
import React from "react";
import Product from "@brand/Product/default/Product";
import { productShape } from "app/utils/propTypes";
import "./product-list.scss";
import classnames from "classnames";

const ProductList = ({ products = [] }) => (
	<div className="product-list">
		{products.map((product, index) => {
			return (
				<div
					key={product.id || (product.merchandising && product.merchandising.code)}
					className={classnames("product-list__item")}
				>
					<Product product={product} position={index} />
				</div>
			);
		})}
	</div>
);

ProductList.propTypes = {
	products: PropTypes.arrayOf(productShape),
};

export default ProductList;
